export default __webpack_public_path__ + "static/media/maduro2.da629f8c.png";